import { CheckboxState } from '@atlassian/jira-bulk-operations-core/src/common/types.tsx';

type Props = {
	selectedIssueIds: number[];
	selectableIssueIds: number[];
	selectionMode: boolean;
};

export const getCardListCheckboxState = ({
	selectedIssueIds,
	selectableIssueIds,
	selectionMode,
}: Props): CheckboxState => {
	const selectedSelectableIssueIds = selectableIssueIds.filter((id) =>
		selectedIssueIds.includes(id),
	);

	if (
		selectableIssueIds.length === selectedSelectableIssueIds.length &&
		selectedSelectableIssueIds.length > 0 &&
		selectionMode
	) {
		return CheckboxState.CHECKED;
	}
	if (selectedIssueIds.length > 0) {
		if (selectedIssueIds.length === 1) {
			if (selectionMode) {
				return CheckboxState.INDETERMINATE;
			}
			return CheckboxState.UNCHECKED;
		}
		return CheckboxState.INDETERMINATE;
	}
	return CheckboxState.UNCHECKED;
};
